export const memberTypes = {
  PI: 'PI',
  CRC: 'CRC',
  OTHER: 'OTHER'
}
